<style lang="scss" scoped>
    .table {
        width: 100%;
        border-spacing: 0px 10px;
        &:before {
            display: none !important;
        }
    }
    /deep/ .listTable table{
        width: 100% !important;
    }
    /deep/ .listTable table tr th{
        text-align: center !important;
    }
    /deep/ .listTable table tr td{
        text-align: center !important;
    }
</style>
<template>
    <div>
        <div class="update_wrap">
            <span>刷新时间: {{lodeTime}}</span>
            <img src="../../assets/img/update_btn.png" @click="refresh" alt="">
        </div>
        <Table :columns="tableColumns" :data="dataList" class="listTable m-t-10"></Table>
        <div class="textRight m-t-10">
            <span class="fLeft lh32">总有功(kW)</span>
        </div>
        <line-chart class="m-t-10" :id="'line-chart-0'" :height="'240px'" :y="lineData.y" :x="lineData.x" :colorObj="colorObj"></line-chart>
        <div class="m-t-10">
            <span>总有功(kW)</span>
        </div>
        <table class="ivu-table table m-t-10" cellspacing="0" cellpadding="0">
            <tr>
                <th>
                    <span class="ivu-table-cell">最大负荷</span>
                </th>
                <th>
                    <span class="ivu-table-cell">发生时间</span>
                </th>
                <th>
                    <span class="ivu-table-cell">最小负荷</span>
                </th>
                <th>
                    <span class="ivu-table-cell">发生时间</span>
                </th>
                <th>
                    <span class="ivu-table-cell">平均负荷</span>
                </th>
                <th>
                    <span class="ivu-table-cell">峰谷差</span>
                </th>
                <th>
                    <span class="ivu-table-cell">负荷率</span>
                </th>
                <th>
                    <span class="ivu-table-cell">峰谷差率</span>
                </th>
            </tr>
            <tr>
                <th>
                    <span class="ivu-table-cell">{{statistics.maxValue}}</span>
                </th>
                 <th>
                    <span class="ivu-table-cell">{{statistics.maxTime}}</span>
                </th>
                 <th>
                    <span class="ivu-table-cell">{{statistics.minValue}}</span>
                </th>
                 <th>
                    <span class="ivu-table-cell">{{statistics.minTime}}</span>
                </th>
                 <th>
                    <span class="ivu-table-cell">{{statistics.meanValue}}</span>
                </th>
                 <th>
                    <span class="ivu-table-cell">{{statistics.differenceValue}}</span>
                </th>
                 <th>
                    <span class="ivu-table-cell">{{statistics.rate}}</span>
                </th>
                 <th>
                    <span class="ivu-table-cell">{{statistics.differenceRate}}</span>
                </th>
            </tr>
        </table>
    </div>
</template>
<script>
    import lineChart from '@/components/line.vue';
    import {getDate} from '@/assets/js/index.js';
// 随机字符串
import getRandVal, {getTime} from '@/assets/js/index';
// 加密
import Base64 from '@/assets/js/base64.js';
import md5 from 'js-md5';
    export default {
        name: 'wit-electric-voltage',
        props: {
            id: ''
        },
        data() {
            return {
                lineData: {
                    x: [],
                    y: [],
                },
                loadValue: {},
                colorObj:{},
                lodeTime: '',
                statistics: {},
                tableColumns: [],
                dataList: [],
                loginData: {},
            };
        },
        mounted() {
            this.getList();
            this.loginData = JSON.parse(window.localStorage.getItem('loginData'));
        },
        methods: {
             //获取数据开始
    getPwdHash(pwd, data) {
        var sha = md5(pwd + data);
        var base = new Base64();
        var pwdHashStr = base.encode(sha);
        return pwdHashStr;
    },
            refresh() {
                this.lodeTime = getDate(new Date().getTime(), 'year');
                this.getTable();
            },
            getList() {
                this.refresh();
                this.getTable();
                this.getChart();
                this.getDetail();
            },
            getChart() {
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/graph/${this.id}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'fh'
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            let arrX = [], arrY = {}, index = 0;
                            for (let item in res.data.data) {
                                let obj = res.data.data[item];
                                this.colorObj[item] = obj[0].pointTypeCode
                                for (let y = 0; y < obj.length; y++) {
                                    if (index === 0) arrX.push(obj[y]['time'].substring(10,obj[y]['time'].length-1));
                                    if (arrY[item] && arrY[item].length) {
                                        arrY[item].push(obj[y]['value'])
                                    } else {
                                        arrY[item] = [obj[y]['value']];
                                    }
                                }
                                if (arrX.length) index = 1;
                            }
                            let translate = {
                                '今日':arrY.today,
                                '昨日':arrY.yesterday,
                            }
                            this.lineData['x'] = arrX;
                            this.lineData['y'] = translate;
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            getTable() {
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/pointNowValue/${this.id}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'fh'
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            let arr=[],arr1=[],obj = {};
                            res.data.data.map((value,index) => {
                                arr.push({
                                    title: value.pointName+value.unit,
                                    key: `value${index}`,
                                    width: '100%',
                                })
                                obj[`value${index}`] = value.value;
                            })
                            arr1.push(obj);
                            this.tableColumns = arr;
                            this.dataList = arr1;
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            getDetail() {
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/loadValue/${this.id}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'fh'
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res && res.data.data[0]) {
                            console.log(res.data.data[0].maxTime == '~')
                            this.statistics = res.data.data && res.data.data[0];
                            
                            this.statistics.maxTime = res.data.data[0].maxTime == '~' ? '~' : getDate(Number(res.data.data[0].maxTime), 'year');
                            this.statistics.minTime = res.data.data[0].minTime == '~' ? '~' : getDate(Number(res.data.data[0].minTime), 'year');
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
        }
        ,
        watch: {
            id() {
                this.getList()
            }
        },
        components: {
            lineChart
        }
    }
    ;
</script>


// WEBPACK FOOTER //
// src/components/wit-electric-monitor/wit-electric-load.vue